<template>
  <div>
    <div v-if="!hasErrorInAgreement" class="fla fla--fast-track content-width">
      <div>
        <LicenseRenderer
          ref="licenseRenderer"
          :licenseName="licenseName"
          @input="handleLicenseUpdate"
          :form="formDefinition"
        />

        <div style="text-align: right;">

          <el-popover
            placement="top-end"
            width="200"
            trigger="hover"
            :disabled="form['terms-and-conditions']"
            content="You have to agree to the Terms and Conditions above first."
          >
            <span
              slot="reference"
              style="display: inline-block"
            >
              <el-button
                type="primary"
                @click="submit"
                :disabled="!form['terms-and-conditions']"
              >
                Submit
              </el-button>
            </span>
          </el-popover>

        </div>
      </div>

      <!-- Other related HTML codes -->
      <el-dialog
        :visible.sync="showEndDialogue"
        fullscreen
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      >
        <div
          v-loading="loading"
          element-loading-text="Submitting..."
        >
          <ThankYou
            :style="{ visibility: (loading) ? 'hidden' : 'visible' }"
          />
        </div>
      </el-dialog>
    </div>
    <Fallback v-else />
  </div>
</template>

<script>
import webcall from '@/libs/webcall';
import NOTIFY_CONSTANTS from '@/config/notify-constants';
import licenseParentMixin from '../mixins/licenseParentMixin';
// Others
import ThankYou from '../Others/ThankYou';
// Common
import LicenseRenderer from '../CommonLicenseComponents/LicenseRenderer';

export default {
  mixins: [
    licenseParentMixin,
  ],
  components: {
    LicenseRenderer,
    ThankYou,
  },
  props: {
    formField: {
      type: Object,
      required: true,
    },
    specification: {
      type: Object,
      required: true,
    },
    licenseName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: licenseParentMixin.functionalMethods.generateFormData(
        this.$options.propsData.formField,
        {
          'links': '', // This attribute is needed for the form to submit through
          'rights_general': undefined,
          'rights_advertising': undefined,
          'rights_media': undefined,
          'terms-and-conditions': undefined,
          'films': [{
            title: '',
            name: '1',
            directors: [{
              editable: true,
              role: 'director',
            }],
            contributors: [],
          }],
          'filmmakerDetails': {},
          'additional_agreements': {},
        }
      ),
      // General
      loading: false,
      showEndDialogue: false,
      isSubmitted: false,
    };
  },
  computed: {
    agreement() {
      return this.$store.state.agreement;
    },
    formDefinition() {
      return licenseParentMixin.functionalMethods.generateFormDefinition(
        this.$options.propsData.formField,
        this,
        'form',
      );
    },
  },
  methods: {
    handleLicenseUpdate([fieldname, fieldValue]) {
      // This will handle the update for primitive value
      // Complex object such as film details and filmmaker are handled by mutating inner properties of object
      // (This is not the best way, if you have time to implement a proper solution, consider doing it.)
      this.form[fieldname] = fieldValue;
    },

    submit() {
      // Form to validate
      const formValidationPromises = [
        this.$refs.licenseRenderer.componentReference.formFilmmakerDetails,
        this.$refs.licenseRenderer.componentReference.formFilms,
      ].map(formInstance => formInstance.validate());
      // Check status
      Promise.all(formValidationPromises)
        .then(() => this.sendForm())
        .catch((formInstance) => {
          if (formInstance instanceof Error) { // Denote network error. Not a validation error.
            this.$notify.error({
              title: 'Opps',
              message: formInstance.message,
              duration: NOTIFY_CONSTANTS.DURATION.LONG,
            });
            throw formInstance;
          }

          this.$notify.error({
            title: 'Opps',
            message: 'Some of the fields are empty or incorrectly filled.',
            duration: NOTIFY_CONSTANTS.DURATION.MEDIUM,
          });

          // Scroll element into view
          //  - These code are made to handle special cases where the element are hidden
          let node = formInstance.$el;
          let searchDepth = 5;
          while (node.clientWidth === 0 && searchDepth > 0) {
          // Assuming that parentNode always exist, since search will at most
          // reaches <html>, which should have width > 0
            node = node.parentNode;
            searchDepth -= 1;
          }
          if (node.clientWidth === 0) { node = document.body; }

          // Not all browser support scroll option. This effect will be applied progressively
          node.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'nearest' });
        });
    },
    sendForm() {
      this.showEndDialogue = true;
      this.loading = true;

      const films = this.form.films.map((film) => {
        // Copy filmObject and remove directors and contributors
        const result = { ...film };
        delete result.directors;
        delete result.contributors;
        // Build a collaborators object
        result.collaborators = [
          ...film.contributors,
          ...film.directors,
        ];
        // Return the processed result
        return result;
      });

      return webcall.submission.fastTrack({
        ...this.form,
        films,
        ...this.form.filmmakerDetails,
      })
        .then(() => {
          this.loading = false;
          this.isSubmitted = true;
        })
        .catch((error) => {
          this.loading = false;
          this.showEndDialogue = false;

          this.$notify.error({
            title: 'Error',
            message: error.data.message,
            duration: NOTIFY_CONSTANTS.DURATION.LONG,
          });
          throw error;
        });
    },
  },
};
</script>

<style lang="scss">
$negative-margin: $--main-padding * 0.75;

.fla__card {
  box-sizing: border-box;
  background-color: rgba(255,255,255,0.8);

  margin: auto #{-$negative-margin};
  @include breakpoint-up(xs) {
    margin: auto;
  }
}

.fla__body > * {
  margin-bottom: 3em;
}

</style>



// WEBPACK FOOTER //
// src/components/Licenses/FilmLicenseAgreementFastTrack/FastTrackPage.vue